import { IdentifiableData } from '@shared/models/generictablecolumn';

export class SimpleActionManager<T extends IdentifiableData> {
	currentMenuRowId: string | null = null;

	actions: actionDefintion<T>[] = [];

	public currentVisibleActions: actionInfo<T>[] = [];

	setActions(actions: actionDefintion<T>[]) {
		this.actions = actions;
	}

	prepareVisibleActions(rowData: T) {
		this.currentMenuRowId = rowData.id;
		this.currentVisibleActions = (this.actions || []).reduce((acc: actionInfo<T>[], action) => {
			const actioninfo: actionInfo<T> = {
				definition: action, // action definition
				disabled: false, // initially all actions are enabled
			};

			if (action.filter && !action.filter(rowData)) {
				actioninfo.disabled = true; // skip actions that should be disabled
				actioninfo.message = action.filterMessage; // message to show when filter is applied
			}

			if (action.disableFilter && action.disableFilter(rowData)) {
				actioninfo.disabled = true; // skip actions that should be disabled
				actioninfo.message = action.filterDisableMessage; // message to show when filter is disabled
			}

			if (actioninfo.message !== undefined || !actioninfo.disabled || (actioninfo.disabled && !(action.hideOnDisabled !== undefined ? action.hideOnDisabled : true))) {
				// skip actions that should be disabled
				return acc.concat(actioninfo);
			}

			return acc;
		}, [] as actionInfo<T>[]);
	}
}

export interface actionInfo<T> {
	definition: actionDefintion<T>;
	disabled: boolean;
	message?: string; // message to show when action is disabled
}

export interface actionDefintion<T = any> {
	icon?: string; // new: icon to show in the action menu
	title: string;
	handler: string;
	hideOnDisabled?: boolean; // new: hide action when disabled
	filterMessage?: string; // new: message to show when filter is applied
	filter?: (rowData: T) => boolean;
	filterDisableMessage?: string; // new: message to show when filter is disabled
	disableFilter?: (rowData: T) => boolean;
}
